module.exports = __webpack_public_path__ + "static/media/BlueStroke10.3c0bd4a6.svg";